import React from "react";
import CrudManager from "@/components/admin/CrudManager";

export default function MachineLocationsAdmin() {
  return (
    <CrudManager
      title="Machine Locations"
      description="Manage installed machine locations shown on the map."
      endpoint="machine-locations"
      fields={[
        { name: "name", label: "Venue / Location Name", type: "text" },
        { name: "type", label: "Type", type: "select", options: ["Petrol Pump", "Corporate Office", "Mall", "Campus", "Sports Facility", "Public Space", "Other"] },
        { name: "address", label: "Address", type: "textarea", rows: 2 },
        { name: "city", label: "City", type: "text" },
        { name: "state", label: "State", type: "text" },
        { name: "lat", label: "Latitude (optional)", type: "text" },
        { name: "lng", label: "Longitude (optional)", type: "text" },
        { name: "order", label: "Display Order", type: "number" },
        { name: "active", label: "Visible", type: "switch" },
      ]}
      columns={[
        { name: "name", label: "Location", type: "text" },
        { name: "city", label: "City", type: "text" },
        { name: "type", label: "Type", type: "text" },
        { name: "active", label: "Status", type: "switch" },
      ]}
    />
  );
}
